<template>
    <section class="px-4 py-8 mx-auto w-full max-w-5xl md:py-12 lg:py-16">
     <div class="flex flex-col gap-x-2 gap-y-3 justify-center items-center md:gap-x-4 sm:flex-row">

      <nuxt-img
                  :src="imageSrc"
                  alt="logo"
                  width="104"
                  height="110"
                  loading="lazy"
                  class="w-20 md:-ml-24 xl:w-24"
              ></nuxt-img>


      <div
        class="text-xl font-bold text-center md:text-2xl lg:text-2xl xl:text-3xl xl:leading-10 font-ww-bold"
        v-html="heading"
      ></div>
     </div>
   
  
      <div
        class="mt-6 text-center font-ww-light md:text-17 !leading-5"
        v-html="subText"
      ></div>
    </section>
  </template>
  
  <script setup>
  const props = defineProps({
    imageSrc: {
      type: String,
      default: "/assets/images/guaranteed-img.png"
    },
    heading: {
      type: String,
      default: "Sip It, Love It, Or You Don’t Pay” Guarantee (30-Day Risk-Free Promise)"
    },
    subText: {
      type: String,
      default: `We’re so confident you’ll love the smooth taste and feel-good benefits of our solvent-free decaf, we’re flipping the risk entirely on us.Try your first bag of Lifeboost Decaf for 30 days — brew it, drink it daily, share it with friends. If you don’t feel it’s the best-tasting, cleanest decaf you’ve ever had… just let us know. We’ll refund every penny of your order. No questions. No hassle. No fine print. Because your health — and your trust — deserve that level of respect.`
    }
  });
  
  defineBuilderComponent({
    friendlyName: "HeadingImageWhitText",
    inputs: [
      {
        name: "imageSrc",
        type: "file",
        allowedFileTypes: ["jpeg", "jpg", "png", "svg", "webp"],
        friendlyName: "Image",
        defaultValue: "/assets/images/guaranteed-img.png"
      },
      {
        name: "heading",
        type: "richText",
        friendlyName: "Heading",
        defaultValue: "Sip It, Love It, Or You Don’t Pay” Guarantee (30-Day Risk-Free Promise)"
      },
      {
        name: "subText",
        type: "richText",
        friendlyName: "Subtext",
        defaultValue: `We’re so confident you’ll love the smooth taste and feel-good benefits of our solvent-free decaf, we’re flipping the risk entirely on us.Try your first bag of Lifeboost Decaf for 30 days — brew it, drink it daily, share it with friends. If you don’t feel it’s the best-tasting, cleanest decaf you’ve ever had… just let us know. We’ll refund every penny of your order. No questions. No hassle. No fine print. Because your health — and your trust — deserve that level of respect.`
      }
    ]
  });
  </script>
  